import { http } from '../helpers/http'

const findAll = () => {
  return http.get('/recipients')
}

const find = recipientId => {
  return http.get(`/recipient/${recipientId}`)
}

const create = recipient => {
  return http.post(`/recipients`, { label: recipient })
}

const update = (recipientId, recipient) => {
  return http.patch(`/recipient/${recipientId}`, { label: recipient })
}

const remove = recipientId => {
  return http.delete(`recipient/${recipientId}`)
}

export const recipientService = {
  findAll,
  find,
  create,
  update,
  remove
}
